// src/components/Header.jsx

import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Offcanvas } from "bootstrap"; // ✅ Bootstrap import

import logo from "../assets/img/header_top_logo.svg";
import Img1 from "../assets/img/phone.svg";
import Img2 from "../assets/img/email.svg";
import Img3 from "../assets/img/whatsapp.svg";
import Img4 from "../assets/img/workdayz-logo.svg";
import mobilelogo from "../assets/img/logo.png";

import Img5 from "../assets/img/ambence-logo.svg";

import Img6 from "../assets/img/icon/carbon_industry.svg";
import Img7 from "../assets/img/icon/icon2.svg";
import Img8 from "../assets/img/icon/icon3.svg";
import Img9 from "../assets/img/icon/icon4.svg";
import Img10 from "../assets/img/icon/icon5.svg";
import Img11 from "../assets/img/icon/icon6.svg";
import Imgicon7 from "../assets/img/icon/icon7.svg";
import Img12 from "../assets/img/icon/icon8.svg";
import Icon1 from "../assets/img/close-circle.svg";

import Img13 from "../assets/img/icon/bed.svg";
import Img14 from "../assets/img/icon/pillows.svg";
import Img15 from "../assets/img/icon/hugeicons_curtains.svg";
import Img16 from "../assets/img/icon/roller.svg";
import Img17 from "../assets/img/icon/streamline_shelf.svg";

const Header = () => {
  const location = useLocation(); // current URL
  const [openDropdown, setOpenDropdown] = useState(false);

  const isActive = (path) => (location.pathname === path ? "active" : "");

  // ✅ Offcanvas close karne ka function
  const closeOffcanvas = () => {
    const offcanvasEl = document.getElementById("offcanvasNavbar");
    const offcanvas = Offcanvas.getInstance(offcanvasEl);

    if (offcanvas) {
      offcanvas.hide();
    }
  };

  // ✅ Offcanvas close hone ke baad cleanup
  useEffect(() => {
    const el = document.getElementById("offcanvasNavbar");
    if (!el) return;

    const handleHidden = () => {
      // Bootstrap ne jo inline styles lagaye, unhe reset karo
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("paddingRight");

      // Backdrop agar bacha ho to hatao
      document.querySelectorAll(".offcanvas-backdrop").forEach((b) => b.remove());

      // Extra classes bhi clear
      document.body.classList.remove("modal-open", "show");
    };

    el.addEventListener("hidden.bs.offcanvas", handleHidden);

    return () => {
      el.removeEventListener("hidden.bs.offcanvas", handleHidden);
    };
  }, []);

  const handleDropdownToggle = () => {
    // Agar mobile width < 992px hai (Bootstrap lg breakpoint)
    if (window.innerWidth < 992) {
      setOpenDropdown(!openDropdown);
    }
  };

  return (
    <header>
      {/* ---- Top Bar ---- */}
      <div className="header_top">
        <div className="container">
          <div className="row">
            <div className="col-6 saragogilogo">
              <div className="header_top_left">
                <span>
                  <a className="navbar-brand" href="/">
                    <img src={logo} alt="" className="logom" />
                    <h2>The Saraogi Clothing Company</h2>
                  </a>
                </span>
              </div>
            </div>
            <div className="col-6 saragogilogocall">
              <div className="header_top_right">
                <span>
                  <a className="navbar-brand" href="tel:+917358376222">
                    <img src={Img1} alt="" className="logom" />
                    <p> +91-7358376222</p>
                  </a>
                </span>
                <span>
                  <a className="navbar-brand" href="mailto:contact@saraogi.in">
                    <img src={Img2} alt="" className="logom" />
                    <p>contact@saraogi.in</p>
                  </a>
                </span>
                <a
                  className="whatsapp_btn"
                  href="https://wa.me/917358376222"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={Img3} alt="" className="whatsapp_img" />
                  <span>Whatsapp</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---- Navbar ---- */}
      <div className="header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav className="navbar navbar-expand-md sticky-top">
                <div className="container flex-row">
                  <a className="navbar-brand" href="/product">
                    <img src={Img4} alt="" className="logom desktoplogo"  />
                    <img src={mobilelogo} alt="" className="logom mobilelogo" width={'50%'}  />
                  </a>

                  {/* Toggle Button for Mobile */}
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasNavbar"
                    aria-controls="offcanvasNavbar"
                  >
                    <span className="barsc"></span>
                    <span className="barsc"></span>
                    <span className="barsc"></span>
                  </button>

                  {/* Offcanvas Menu */}
                  <div
                    className="offcanvas offcanvas-end"
                    tabIndex="-1"
                    id="offcanvasNavbar"
                    aria-labelledby="offcanvasNavbarLabel"
                  >
                    <div className="offcanvas-header">
                      <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                        Saraogi
                      </h5>
                      <button
                        type="button"
                        className="btnclose"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                      >
                        <img src={Icon1} alt=""></img>
                      </button>
                    </div>

                    <div className="offcanvas-body">
                      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                          <Link
                            className={`nav-link ${isActive("/")}`}
                            to="/"
                            onClick={closeOffcanvas}
                          >
                            Home
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className={`nav-link ${isActive("/about-us")}`}
                            to="/about-us"
                            onClick={closeOffcanvas}
                          >
                            About Us
                          </Link>
                        </li>

                        <li
                          className={`nav-item dropdown ${
                            openDropdown ? "show" : ""
                          }`}
                          onMouseEnter={() => {
                            if (window.innerWidth >= 992) setOpenDropdown(true);
                          }}
                          onMouseLeave={() => {
                            if (window.innerWidth >= 992)
                              setOpenDropdown(false);
                          }}
                        >
                          <Link
                            className={`nav-link dropdown-toggle ${isActive(
                              "/product"
                            )}`}
                            to="/product"
                            role="button"
                            onClick={handleDropdownToggle}
                          >
                            Our Products
                          </Link>

                          {/* Custom Dropdown */}
                          <div
                            className={`dropdown-menu p-4 shadow-lg rounded-lg ${
                              openDropdown ? "show" : ""
                            }`}
                            style={{
                              minWidth: "1170px",
                              left: "-400px",
                              border: "none",
                              borderRadius: "24px",
                            }}
                          >
                            <div className="dropmenu_outer">
                              <div className="lef_mega">
                                <h6 className="fw-bold mb-3">
                                  Industries We Serve
                                </h6>
                                <div className="row g-3">
                                  <div className="col-6 ">
                                    <Link
                                      to="/uniform-manufacturer/industrial"
                                      className="d-flex align-items-start p-2 rounded hover-bg "
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Img6} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">
                                          Industrial & Manufacturing
                                        </h6>
                                        <p className="text-muted small mb-0">
                                          Built for Durability. Designed for
                                          Safety.
                                        </p>
                                      </div>
                                    </Link>
                                    <Link
                                      to="/uniform-manufacturer/hospitality-resorts"
                                      className="d-flex align-items-start p-2 rounded hover-bg"
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Imgicon7} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">
                                          Hospitality & Resorts
                                        </h6>
                                        <p className="text-muted small mb-0">
                                          Where Uniforms Reflect Warmth & El..
                                        </p>
                                      </div>
                                    </Link>
                                    <Link
                                      to="/uniform-manufacturer/retail-brand-spaces"
                                      className="d-flex align-items-start p-2 rounded hover-bg"
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Img7} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">
                                          Retail & Corporate
                                        </h6>
                                        <p className="text-muted small mb-0">
                                          Retail-Ready Uniforms with Brand..
                                        </p>
                                      </div>
                                    </Link>
                                    <Link
                                      to="/uniform-manufacturer/government-police-defense"
                                      className="d-flex align-items-start p-2 rounded hover-bg"
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Img9} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">
                                          Government, Police & Defense
                                        </h6>
                                        <p className="text-muted small mb-0">
                                          Proudly Serving Those Who Serve
                                        </p>
                                      </div>
                                    </Link>
                                  </div>

                                  <div className="col-6 ">
                                    <Link
                                      to="/uniform-manufacturer/pilot-uniforms-aviation"
                                      className="d-flex align-items-start p-2 rounded hover-bg"
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Img12} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">Aviation</h6>
                                        <p className="text-muted small mb-0">
                                          Polished Look for Everyday Impact
                                        </p>
                                      </div>
                                    </Link>
                                    <Link
                                      to="/uniform-manufacturer/healthcare-clinics-wellness"
                                      className="d-flex align-items-start p-2 rounded hover-bg"
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Img10} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">
                                          Healthcare, Clinics & Wellness
                                        </h6>
                                        <p className="text-muted small mb-0">
                                          Dependable Wear for Demanding R..
                                        </p>
                                      </div>
                                    </Link>
                                    <Link
                                      to="/uniform-manufacturer/educational-institutions"
                                      className="d-flex align-items-start p-2 rounded hover-bg"
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Img11} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">
                                          Educational Institutions
                                        </h6>
                                        <p className="text-muted small mb-0">
                                          Smart Uniform for Bright Minds
                                        </p>
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              <div className="rig_mega">
                                <h6 className="fw-bold mb-3">
                                    Furnishings
                                </h6>
                                <div className="row g-3">
                                  <div className="col-12">
                                    <Link
                                      to="/ambience-and-harmony"
                                      className="d-flex align-items-start p-2 rounded hover-bg"
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Img13} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">
                                          Bed Linens
                                        </h6>
                                      </div>
                                    </Link>
                                    <Link
                                      to="/ambience-and-harmony"
                                      className="d-flex align-items-start p-2 rounded hover-bg"
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Img14} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">
                                          Pillows / Cushions
                                        </h6>
                                      </div>
                                    </Link>
                                    <Link
                                      to="/ambience-and-harmony"
                                      className="d-flex align-items-start p-2 rounded hover-bg"
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Img15} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">
                                          Curtains
                                        </h6>
                                      </div>
                                    </Link>
                                    <Link
                                      to="/ambience-and-harmony"
                                      className="d-flex align-items-start p-2 rounded hover-bg"
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Img16} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">
                                          Roller Blinds
                                        </h6>
                                      </div>
                                    </Link>
                                    <Link
                                      to="/ambience-and-harmony"
                                      className="d-flex align-items-start p-2 rounded hover-bg"
                                      onClick={closeOffcanvas}
                                    >
                                      <span className="mbricon">
                                        <img src={Img17} alt="" />
                                      </span>
                                      <div>
                                        <h6 className="mb-1">
                                          Bathroom Furnishings
                                        </h6>
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li className="nav-item">
                          <Link
                            className={`nav-link ${isActive("/design-studio")}`}
                            to="/design-studio"
                            onClick={closeOffcanvas}
                          >
                            Design Studio
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className={`nav-link ${isActive("/project")}`}
                            to="/project"
                            onClick={closeOffcanvas}
                          >
                            Our Projects
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className={`nav-link ${isActive("/blog")}`}
                            to="/blog"
                            onClick={closeOffcanvas}
                          >
                            Blogs
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className={`nav-link ${isActive("/contact")}`}
                            to="/contact"
                            onClick={closeOffcanvas}
                          >
                            Contact Us
                          </Link>
                        </li>
                       
                      </ul>
                    </div>
                  </div>

                  <a className="navbar-brand navbar_brand" href="/ambience-and-harmony">
                    <img src={Img5} alt="" className="logom" />
                  </a>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
